import { I18N_NAMESPACES, I18N_TRANSLATIONS_BASE_PATH } from '../../constants/i18nConstants';
import { i18nConfigurationGeneral } from './i18nConfigurationGeneral';
const generateFrontEndI18nInitOptions = (version, translationLanguage = '', translationEndpoint = '') => (Object.assign(Object.assign(Object.assign(Object.assign({}, i18nConfigurationGeneral), { fallbackLng: translationLanguage || i18nConfigurationGeneral.fallbackLng, preload: Object.keys(I18N_NAMESPACES) }), {
    cache: Object.assign(Object.assign({}, i18nConfigurationGeneral.cache), { enabled: true, versions: Object.keys(i18nConfigurationGeneral.supportedLngs).reduce((previous, current) => {
            previous[current] = version;
            return previous;
        }, {}) }),
}), {
    backend: Object.assign(Object.assign({}, i18nConfigurationGeneral.backend), { loadPath: `${translationEndpoint}${I18N_TRANSLATIONS_BASE_PATH}`, queryStringParams: {
            version: version,
        }, parse: function (data) {
            return typeof data === 'string' ? JSON.parse(data) : data;
        } }),
}));
export default (version, translationLanguage = '', translationEndpoint = '') => generateFrontEndI18nInitOptions(version, translationLanguage, translationEndpoint);
